<img
	alt="Logo of Law Labs Inc"
	src="/assets/images/lawlabs_logo.png"
	title="Law Labs Inc Logo"
	class="mb-8"
/>
<div class="text-center max-w-xl mx-auto">
	<h1 class="h1 mb-4">Sync by Closer Terms of Use</h1>
	<p class="p mb-12">January 2024</p>
</div>

<section class="space-y-8 mb-8 text-justify">
	<article class="space-y-4">
		<p>
			This agreement (the “Agreement”) is a legal agreement between you, either
			an individual or a single legal entity (“You” or “you”), and LawLabs Inc.
			(“LawLabs”). This Agreement governs your use of the Sync mortgage
			processing p latform, which allows for the transfer and conversion of
			information between financial institutions and lawyers in relation to the
			provision and management of mortgage mandates and the conclusion of
			mortgages (“Sync”) in connection with the processing of all mortgage
			instructions (the “Mortgage Instructions”) that you may receive and accept
			through Sync from supported financial institutions (the “Financial
			Institutions”).
		</p>

		<p>
			By clicking on the “I accept” button as part of the Sync enrollment
			process, you acknowledge and confirm that you have read, understand and
			agree with the terms and conditions of this Agreement and that you will
			comply with them in all of your uses of Sync and in processing all
			Mortgage Instructions. Your continued use of Sync, the acceptance of any
			Mortgage Instructions and the processing of any Mortgage Instructions by
			you or on your behalf will be considered continued acceptance of this
			Agreement. If you do not agree to these terms and conditions, simply click
			on the “cancel” button to stop enrollment.
		</p>
	</article>

	<article class="space-y-4">
		<h2 class="h2">1. Eligibility</h2>
		<p>
			Sync is only to be used by lawyers who are permitted to practice law and
			are in good standing with the appropriate provincial law society and who,
			in each case, maintain a valid email address with said law society.
		</p>
		<p>
			You warrant, and you will be considered to warrant each time you accept
			Mortgage Instructions (directly or through your Authorized Representative,
			as hereinafter defined), that you meet the above eligibility conditions
			or, if you are an Authorized Representative, that you are duly authorized
			to act for a lawyer enrolled in Sync.
		</p>
		<p>
			You agree to discontinue use of Sync when you are no longer a lawyer
			permitted to practice law or in good standing or when your law society
			email address is used by any unauthorized person, compromised in any way
			or no longer in force or, if you are an Authorized Representative, when
			you are no longer duly authorized to act for the enrolled lawyer involved
			or when you become aware of any of the above circumstances.
		</p>
	</article>

	<article class="space-y-4">
		<h2 class="h2">2. Permitted Access</h2>
		<p>
			You acknowledge that you have been provided with a Sync account that
			permits you to access and make use of Sync to process Mortgage
			Instructions and that such usage is subject to the terms of this
			Agreement.
		</p>
		<p>
			You warrant that all information provided to LawLabs in connection with
			your enrolment and authentication was and continues to be true and
			correct. You agree to update any outdated information by notifying LawLabs
			in writing forthwith.
		</p>
		<p>
			You agree to keep your account information relating to Sync in confidence
			and not to disclose it to any person except, if you are a lawyer, on a
			confidential basis to your authorized employees and other representatives
			(including legal assistants with whom you share access on the Mortgage
			Instructions) (your “Authorized Representatives”) who need to know that
			information for the purposes of assisting you in your usage of Sync in
			accordance with this Agreement.
		</p>
		<p>
			You are solely responsible for all uses and disclosures of your Sync
			account information, by and to any other person (including, your
			Authorized Representatives). Should you give access to your Sync account
			information to anyone other than yourself (including your Authorized
			Representatives), you hereby acknowledge and accept full responsibility
			for any of the Mortgage Instructions that are accepted on your behalf. For
			greater clarity, it is your absolute responsibility to keep your account
			information confidential and for your personal use only, and LawLabs shall
			not be responsible for any damages caused to you by breaching this
			requirement. You agree to indemnify and hold LawLabs harmless with respect
			to the foregoing.
		</p>
		<p>
			You agree to be bound by the terms of acceptance of any Mortgage
			Instructions that are accepted using Sync (whether accepted by you
			directly, by your Authorized Representatives or otherwise).
		</p>
		<p>
			You will not use or attempt to use another person’s Sync account
			information nor will you violate the security of Sync.
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">3. Your Responsibilities</h2>
		<p>
			You are solely responsible for the content, completeness and accuracy of
			any information or data you provide to LawLabs, its agents and
			subcontractors for the purpose of transfer and conversion by such parties
			through Sync.
		</p>
		<p>
			You are solely responsible for any professional services provided to your
			clients and associated parties, including those furnished to the Financial
			Institutions that provide Mortgage Instructions.
		</p>
		<p>
			You acknowledge that the Mortgage Instructions must be accepted within the
			time limits prescribed by the relevant Financial Institution.
		</p>
		<p>
			You will abstain from using Sync for purposes other than those for which
			it was designed, and from helping or authorizing other persons to do so.
			You will not copy, reproduce, modify, reverse-engineer, decompile,
			disassemble, distribute or publicly display Sync or any of its components.
			You will not interfere or attempt to interfere with the proper working of
			Sync or any activities conducted using Sync.
		</p>
		<p>
			You will not circumvent, decrypt or bypass any technology that LawLabs
			uses to protect Sync, its customers and their information.
		</p>
		<p>You will not knowingly provide false or misleading information.</p>
		<p>
			You will use Sync for your commercial, industrial or business purposes
			only and not for personal, family household, or resale purposes.
		</p>
		<p>
			You agree that, if any of the terms and conditions of this Agreement is
			breached, LawLabs will be released from any and all responsibility and
			liability towards you regarding Sync, including as to any obligation
			related to warranties or indemnification. In the event of such a breach,
			you will be liable to and agree to indemnify and save harmless LawLabs for
			and against any and all damages, losses and expenses (including reasonable
			legal fees and courts costs) suffered or incurred by LawLabs as a result
			of or in connection with such a breach.
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">4. Ownership of Intellectual Property</h2>
		<p>
			As between LawLabs and you, LawLabs retains all title, ownership, and
			intellectual property rights in and to Sync and associated Documentation,
			and all developments by LawLabs in connection with this Agreement. You
			acknowledge and agree that you are only licensing the right to use Sync
			and associated Documentation and that no sale or other transfer of any
			title or ownership or any proprietary interest of any kind to Sync or
			associated Documentation is contemplated hereunder, other than the sale of
			the limited licenses as expressly granted herein. You shall not allow for
			any duplicates or reproduction of the Software to be made.
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">5. Confidentiality</h2>
		<p>
			Unless otherwise required by law or provided herein, LawLabs will maintain
			the confidentiality of all non-public, information concerning you and
			obtained from you in relation to this Agreement and will not disclose that
			information to anyone, except on a confidential basis to the Financial
			Institutions, and to those of its affiliates that need to know that
			information for making available Sync.
		</p>
		<p>
			You warrant to LawLabs that you have or will have obtained in due course,
			from your clients and all other persons involved, all required consents
			for the collection, use and disclosure by LawLabs of any confidential,
			personal and other non-public information needed in connection with the
			provision of Sync.
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">6. Warranties; Disclaimer of Warranties</h2>
		<p>
			LawLabs agrees to use commercially reasonable efforts to provide Sync and
			related services in accordance with the terms and conditions in this
			Agreement.
		</p>
		<p class="capitalize">
			THE WARRANTIES SET OUT HEREIN ARE THE ONLY WARRANTIES GRANTED. EXCEPT AS
			SPECIFIED IN THIS AGREEMENT, LAWLABS MAKES NO REPRESENTATIONS OR
			WARRANTIES OF ANY TYPE, EXPRESS OR IMPLIED, REGARDING SYNC (INCLUDING THE
			MORTGAGE INSTRUCTIONS), INCLUDING BUT NOT LIMITED TO ANY IMPLIED
			WARRANTIES WITH RESPECT TO THE CONDITION, QUALITY, MERCHANTABILITY OR
			FITNESS OR USE FOR A PARTICULAR PURPOSE, NOR ANY WARRANTIES ARISING FROM A
			COURSE OF PERFORMANCE OR DEALING, OR AS TO THE TRANSMISSION CAPACITY FROM
			THE SYNC INFRASTRUCTURE OR FROM YOURS OR REGARDING THE RELIABILITY OF THE
			SYNC PLATFORM, OR AS TO THE UNINTERRUPTED OR ERROR-FREE OPERATION OF SYNC.
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">7. Limitation of Liability</h2>
		<p class="capitalize">
			LAWLABS WILL NOT BE HELD RESPONSIBLE FOR THE CONTENT, COMPLETENESS OR
			ACCURACY OF ANY INFORMATION OR DATA YOU PROVIDE TO LAWLABS, ITS SUPPLIERS
			AND SUBCONTRACTORS FOR THE PURPOSE OF TRANSFER AND CONVERSION BY LAWLABS,
			ITS SUPPLIERS AND SUBCONTRACTORS THROUGH SYNC. LAWLABS’ ENTIRE LIABILITY
			UNDER THIS AGREEMENT, INCLUDING THAT OF ITS SUPPLIERS AND SUBCONTRACTORS
			OR IN ANY WAY RELATED TO THE SYNC OR ANY RELATED SERVICES WILL BE LIMITED
			TO DIRECT DAMAGES IN AN AMOUNT EQUAL TO THE FEES PAID BY YOU TO LAWLABS
			SOLELY FOR THE USE OF SYNC PURSUANT TO THIS AGREEMENT DURING THE TWELVE
			(12) MONTH PERIOD IMMEDIATELY PRECEDING THE FIRST EVENT GIVING RISE TO THE
			CLAIM; AND (B) NO PARTY WILL BE LIABLE FOR: (i) ANY SPECIAL, PUNITIVE,
			INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES ARISING FROM OR RELATED TO
			THIS AGREEMENT OR IN ANY WAY RELATED TO THE SOFTWARE, THE THIRD PARTY
			SOFTWARE, THE HARDWARE OR ANY RELATED SERVICES; OR (ii) ANY LOSS OF
			REVENUE, PROFITS, GOODWILL OR DATA, OR DATA USE (INCLUDING AS A RESULT OF
			A VIRUS), BUSINESS INTERRUPTION, FAILURE TO REALIZE AN EXPECTED SAVING,
			CORRUPTION OF DATA, OR CLAIMS AGAINST THEM BY ANY THIRD PARTY, EVEN IF THE
			PARTIES ARE ADVISED, OR MAY REASONABLY SUPPOSED TO HAVE BEEN AWARE, OF THE
			POSSIBILITY OF SUCH DAMAGES IN ADVANCE. SUCH LIMITATIONS WILL APPLY
			REGARDLESS OF HOW THE CLAIM ARISES, WHETHER ARISING BASED ON CONTRACT,
			TORT, NEGLIGENCE, OR OTHERWISE AND WILL APPLY TO ALL SCHEDULES, ADDENDA,
			AGREEMENTS AND ATTACHMENTS RELATED TO THIS TERMS OF USE. THE FOREGOING
			LIMITATIONS OF LIABILITY ALLOCATE THE RISKS BETWEEN YOU AND LAWLABS AND
			FORM A MATERIAL BASIS OF THE BARGAIN BETWEEN THE PARTIES. LAWLABS’ PRICING
			REFLECTS THIS ALLOCATION OF RISK AND THE LIMITATION OF LIABILITY SPECIFIED
			HEREIN.
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">8. Termination or Modification</h2>
		<p>
			In addition to all other rights and remedies provided in this Agreement,
			Lawabs reserves the right, at its sole discretion, to modify this
			Agreement, in whole or in part, at any time by notifying you (the
			“Modification”). Any notification of the Modification to this Agreement
			will be presented to you via a pop up on the screen upon your next login
			to Closer. In order to continue to use Sync, you must click on the “I
			accept” button on the pop up on the screen, for the purpose of
			acknowledging and confirming to LawLabs that you have read, understand and
			agree with the terms and conditions of the Modification to this Agreement
			and that you will comply with them in all of your uses of Sync and in
			processing all existing and future Mortgage Instructions. If you do not
			agree to the Modification, simply click on the “I refuse” button and you
			will not proceed further, and will hereafter become inactive on Sync until
			such time that you click the “I accept” button on the pop up on the screen
			within the Sync integration page. Should you refuse the Modification, be
			advised that all your existing Mortgage Instructions in progress will no
			longer be processed electronically using Sync and our customer success
			team will notify the affected Financial Institutions that you will
			hereafter be proceeding manually.
		</p>
		<p>
			LawLabs reserves the right, at its sole discretion, to change, add, or
			remove any features of Sync at any time without notice or liability.
		</p>
		<p>
			LawLabs may terminate, suspend, or discontinue your use of Sync at any
			time upon reasonable notice (if commercially reasonable), and without
			liability if (i) you do not comply with this Agreement; (ii) to comply
			with any applicable law or court order; (iii) in Lawlabs’ sole and
			absolute discretion, you are accessing and/or using Sync for any reason or
			use other than its intended use and/or (iv) LawLabs discontinues the
			provision of the use of Sync to all users.
		</p>
		<p>
			Notwithstanding any other provision contained herein, LawLabs reserves the
			right to immediately and without notice, terminate this Agreement if it
			determines, acting reasonably, (i) that you no longer meet the eligibility
			and other conditions set out in Section 1 hereof, (ii) at the request of a
			Financial Institution, (iii) if an act of bankruptcy or insolvency (as
			defined under applicable law) respecting you has taken place, (iv) if
			termination or suspension is necessary to prevent threats to the privacy,
			security and integrity of your data or data of other users or to the
			performance or availability of Sync; or (v) in the case of any fraud or
			suspected fraud on your behalf.
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">9. Use of Logo for Promotional & Marketing Materials</h2>
		<p>
			LawLabs reserves the right to disclose publicly on its website that you or
			your firm is a user of Sync.
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">10. Miscellaneous</h2>
		<p>
			If a party is unable to perform its obligations under this Agreement,
			other than the payment of monies, due to “Force Majeure Event” (which
			includes fires, explosions, floods, earthquakes, pandemics, other elements
			of nature or acts of God, acts of war, enemy action, terrorism, sabotage
			or civil disorders, strikes, lockouts or other work stoppages or disputes,
			delay or default of carriers, any interruptions, failures or defects in
			internet, telephone, cable or other interconnection service or in
			electronic or mechanical equipment, legislation, order or other decision
			of any government or semi-public authority, and any other contingencies
			that are beyond the reasonable control of that party), it will not be in
			default under this Agreement for the period during which the Force Majeure
			Event lasts. The party experiencing the Force Majeure Event shall give
			written notice to the other party promptly after the occurrence of the
			Force Majeure Event, with details thereof.
		</p>
		<p>
			The provisions of this Agreement are severable and, if any provision of
			this Agreement is held invalid or unenforceable in any jurisdiction, that
			invalidity or unenforceability will not affect or render invalid or
			unenforceable that provision in any other jurisdiction or any other
			provision in any jurisdiction.
		</p>
		<p>
			No failure or delay by a party in exercising any right under this
			Agreement will operate as a waiver thereof nor will any single or partial
			exercise thereof preclude any other or future exercise of any right
			hereunder.
		</p>
		<p>
			This Agreement is binding upon, and inures to the benefit of, the parties
			and their respective successors and permitted assigns. You may not assign
			or transfer any of your rights, interests or obligations under this
			Agreement except with the prior written consent of LawLabs. LawLabs may
			assign or transfer any of its rights, interests or obligations to one or
			more of its affiliates or to a third party upon the sale or other transfer
			of LawLab’s business (or any part thereof) to which this Agreement
			relates, on the condition that such affiliate or transferee, as the case
			may be, agrees to be bound by the terms of this Agreement as if it were a
			party hereto (in which case, upon the date of that undertaking, LawLabs
			will be released from its obligations hereunder).
		</p>
	</article>
	<article class="space-y-4">
		<h2 class="h2">11. Governing Law</h2>
		<p>
			This Agreement is governed by the laws of the Province of Ontario and the
			Country of Canada without regard to conflicts of laws provisions and
			without regard to the United Nations Convention on the International Sale
			of Goods. The jurisdiction and venue for actions related to this Agreement
			will be the provincial courts located in Ontario and both parties submit
			to the personal jurisdiction of those courts.
		</p>
	</article>
</section>
